import { useState } from 'react';
import { initialValues, validationSchema } from './formData';
import { useOrbitFormSection } from '../hooks/useOrbitFormSection';
import { OrbitPrivacyConsentProps } from '../sectionProps';

export const useOrbitPrivacyConsent = ({
    onChangeFormik,
    readOnly,
    seedValues,
}: OrbitPrivacyConsentProps) => {
    const [open, setOpen] = useState(false);

    const { formik } = useOrbitFormSection({
        initialValues,
        validationSchema,
        onChangeFormik,
        readOnly,
        seedValues,
    });

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return {
        formik,
        open,
        handleOpen,
        handleClose,
    };
};
